import { mapState } from 'vuex'

export default {
	computed: {
        ...mapState(['availableLanguages'])
	},
	methods: {
		setDefaultLanguage () {
			let language = 'en'
			if (navigator.language === 'de' && this.checkLanguage('de')) {
				language = 'de'
			} else if (navigator.language === 'se' && this.checkLanguage('se')) {
				language = 'se'
			} else if (navigator.language === 'it' && this.checkLanguage('it')) {
				language = 'it'
			} else if (navigator.language === 'fr' && this.checkLanguage('fr')) {
				language = 'fr'
			} else if (navigator.language === 'es' && this.checkLanguage('es')) {
				language = 'es'
			} else if (navigator.language === 'dk' && this.checkLanguage('dk')) {
				language = 'dk'
			} else if (navigator.language === 'ru' && this.checkLanguage('ru')) {
				language = 'ru'
			}
			return language
		},
		checkLanguage (code) {
			return this.availableLanguages.some(item => item.code === code)
		}
	}
}
